import { Pipe, PipeTransform } from '@angular/core';

import { Formatter } from '../models/Formatter';
import formatValue from '../utils/formatValue';

@Pipe({
    name: 'format',
    standalone: true,
})
export class FormatPipe implements PipeTransform {
    transform(value: number | string | boolean | Date, formatter: Formatter): string {
        return formatValue(value, formatter);
    }
}
